module.exports = __webpack_public_path__ + "img/sales-icon.b220b09d.svg";